// extracted by mini-css-extract-plugin
export var container = "_s6-0";
export var dotAnimation = "_s6-2";
export var dotsLoading = "_s6-1";